import React from 'react';
import { Link } from "react-router-dom";
import clsx from 'clsx';

import Row from './Layout/Row';
import Wrapper from './Layout/Wrapper';

import Labels from './Labels';
import ShyTitleComponent from './ShyTitleComponent';

const ExhibitionTeaser = ({ image, text, targetUrl, labels, themeClass, withArrow }) => {
    return (
        <Row>
            <Wrapper>
                <LinkWrapper targetUrl={ targetUrl } teaserTitle={ text }>
                    <article className={`c-exhibition-teaser o-exhibition-teaser theme-${themeClass || ''}`}>
                        <div className={clsx("o-mask o-exhibition-teaser__media c-exhibition-teaser__media", { "-smaller-margin": !withArrow })}>
                            { image ? (
                                <img
                                    className="o-mask__image c-exhibition-teaser__media__image"
                                    src={ image.url || '' }
                                    alt={ image.altText || ''}
                                    srcSet={ image.srcSet || '' }
                                    loading="lazy"
                                    width="550"
                                    height="550"
                                    sizes="380px"
                                />
                            ) : null}
                        </div>
                        <p className={ clsx("o-exhibition-teaser__text c-exhibition-teaser__text", { "-with-arrow": withArrow }) }>
                            <ShyTitleComponent text={ text } />
                            { withArrow ? (
                                <svg className="c-exhibition-teaser__text__arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 20" fill="none" aria-hidden="true" focusable="false">
                                    <path d="M25 8.56102C20.6429 8.19672 17.5357 5.28233 17.2857 0L13.9643 0.728599C14.3929 4.44445 16.8214 7.6867 19.6429 8.56102H3.32193e-08L0 11.4026H19.6429C16.8214 12.2769 14.3929 15.5556 13.9643 19.235L17.2857 20C17.5357 14.7177 20.6429 11.7668 25 11.4026V8.56102Z" fill="black"/>
                                </svg>
                            ) : null }
                        </p>
                    </article>
                </LinkWrapper>
                <Labels items={ labels } />
            </Wrapper>
        </Row>
    );
}

export default ExhibitionTeaser;

const LinkWrapper = ({ 
    targetUrl,
    teaserTitle,
    children 
}) => {
    return targetUrl ? ( 
        <Link to={ targetUrl } className="wrapping-link wrapping-link-exhbition-teaser" data-analytics={ teaserTitle }>{ children }</Link> 
    ) : children;
}
